import { AxiosResponse } from 'axios'
import {useQuery, UseQueryOptions, useMutation, UseQueryResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'

export const useGetPagesData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.PAGES,searchOptions]
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Pages}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        cacheTime: 0,
        ...options
    })
}

export const useAddPages = (options?: any) => {
    
    const method = 'POST'
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Pages}`,
        method,
        data
    }), options)
}

export const useUpdatePages = (options?: any) => {
    
    const method = 'PUT'
    return useMutation(({data, id}: {data: any, id: any})=> HttpRequest({
        url: `${APIEndpoints.Pages}/${id}`,
        method,
        data
    }), options)
}

export const useDeletePages = (options?: any) => {
    
    const method = 'DELETE'
    return useMutation(({id}: {id: any})=> HttpRequest({
        url: `${APIEndpoints.Pages}/${id}`,
        method,
    }), options)
}

export const useStatusPages = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({data, id}: {data: FormData, id: any})=> HttpRequest({
        url: `${APIEndpoints.Pages}/${id}/status`,
        method,
        data
    }), options)
}

export const usePageDetailData = (page_id: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.PAGE, page_id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Pages}/${page_id}`,
            method
        }),
        refetchOnWindowFocus: false,
        ...options
    })
}

export const fetchPageSearchApi = async (search: string) => {
    const { data } = await HttpRequest({
        url: `${APIEndpoints.Pages}/search/all?search=${encodeURIComponent(search)}`,
        method: 'GET'
    });
    return data.results;
};

export const usePagesSearch = (searchTerm: string) => {
    return useQuery({
        queryKey: ["page-search", searchTerm],
        enabled: Boolean(searchTerm.trim()),
        keepPreviousData: true,
        staleTime: 30 * 1000,
        queryFn: async () => {
            const { data } = await HttpRequest({
                url: `${APIEndpoints.Pages}/search/all?search=${encodeURIComponent(searchTerm)}`,
                method: "GET"
            })
            return data
        }
    })
};
